import { apiClient, apiOrigin, type RequestOptions } from '@/services/apiClient';

export type SprintState = 'completed' | 'in_progress' | 'blocked' | 'next' | 'outstanding';

export interface BuildStatusSprint {
  order: number;
  sprintId: string;
  title: string;
  objective: string;
  specPath: string;
  status: SprintState;
  acceptedAt: string | null;
  evidence: Array<{ path: string; exists: boolean }>;
  notes: string | null;
}

export interface BuildStatus {
  generatedAt: string;
  sources: {
    repoRoot: string;
    roadmapPath: string;
    ledgerPath: string;
    ledgerLastUpdated: string | null;
  };
  repo: {
    branch: string | null;
    commit: string | null;
    dirty: boolean | null;
    remote: string | null;
  };
  summary: {
    total: number;
    completed: number;
    inProgress: number;
    blocked: number;
    outstanding: number;
    percentComplete: number;
  };
  nextSprint: BuildStatusSprint | null;
  sprints: BuildStatusSprint[];
}

async function getBuildStatus(options?: RequestOptions): Promise<BuildStatus | null> {
  const result = await apiClient.get<BuildStatus>(`${apiOrigin}/api/build-status`, options);
  if (!result.ok || !result.data) {
    return null;
  }
  return result.data;
}

export const buildStatusClient = {
  getBuildStatus,
};
